import { MenuItem } from '@mui/material'
import { InvoiceReadModel, InvoiceState, MarkInvoiceAsPendingCommand } from '../../GeneratedClients/FreeBillApi';
import { useNotify, useRecordContext, useRefresh, useTranslate } from 'react-admin';
import { apiService } from '../../apiService';
import { useMutation } from "react-query";
import firstLetterToLowerCase from '../../helpers/firstLetterToLowerCase';

interface IProps {
  handleClose: () => void
}

const InvoiceMarkAsPendingMenuItem= ({handleClose}: IProps) => {
  
  const invoice = useRecordContext<InvoiceReadModel>()
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const { mutate, isLoading } = useMutation((command: MarkInvoiceAsPendingCommand) => 
    apiService.InvoicesApi.markInvoiceAsPending({markInvoiceAsPendingCommand: command, id: command.id!}),
    {
      onSuccess: () => {
        notify(translate("resources.invoices.notifications.invoiceStateChanged"))
        refresh()
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )
  const markInvoiceAsPending = () => {
    if(invoice.invoiceState === InvoiceState.Canceled) {
      notify(translate("resources.invoices.dialogs.invalidStateChange", {actualState: translate(`resources.invoices.${firstLetterToLowerCase(InvoiceState.Canceled)}`), newState: translate(`resources.invoices.${firstLetterToLowerCase(InvoiceState.Pending)}`)}), {type: "error"}) 
      return
    }
    if(invoice.invoiceState === InvoiceState.Pending) {
      notify(translate("resources.invoices.dialogs.alreadyThatState", {actualState: translate(`resources.invoices.${firstLetterToLowerCase(InvoiceState.Pending)}`)}), {type: "error"}) 
      return
    }
    const command: MarkInvoiceAsPendingCommand = {
      id: invoice.id,
      userId: invoice.userId,
    }
    mutate(command)
    handleClose()
  }

  return (
    <MenuItem 
      disabled={isLoading} 
      onClick={markInvoiceAsPending} 
      key={"markInvoiceAsPending"}
    >
      {translate(`resources.invoices.pending`)}
    </MenuItem>
  )
}

export default InvoiceMarkAsPendingMenuItem